var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3857 11.877V10.002H20.8857V15.627C20.8857 16.6426 19.9873 17.502 19.0107 17.502H2.76074C1.74512 17.502 0.885742 16.6426 0.885742 15.627V10.002H8.38574V11.877C8.38574 12.2285 8.65918 12.502 9.01074 12.502H12.7607C13.0732 12.502 13.3857 12.2285 13.3857 11.877ZM19.0107 3.75195C19.9873 3.75195 20.8857 4.65039 20.8857 5.62695V8.75195H0.885742V5.62695C0.885742 4.65039 1.74512 3.75195 2.76074 3.75195H5.88574V1.87695C5.88574 0.900391 6.74512 0.00195312 7.76074 0.00195312H14.0107C14.9873 0.00195312 15.8857 0.900391 15.8857 1.87695V3.75195H19.0107ZM13.3857 3.75195V2.50195H8.38574V3.75195H13.3857Z",
    fill: "#F0823E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketInfoIcon);
export default __webpack_public_path__ + "static/media/ticket-info-icon.552ebd5ac64dc5adc3e3027db19baadc.svg";
export { ForwardRef as ReactComponent };